<template>
  <button
    class="plus-icon-opener"
    :aria-label="`Produktinformationen zu ${title} ${isOpen ? 'ausblenden' : 'einblenden'}`"
    :aria-expanded="isOpen"
    :aria-controls="
      isOpen ? `button-content-${title.toLowerCase().replace(/\s+/g, '-')}` : undefined
    "
    @mouseover="isOpen = true"
    @mouseleave="isOpen = false"
    @click.stop="isOpen = !isOpen"
  >
    <span
      class="plus-icon-opener__icon-wrapper"
      :class="[
        `plus-icon-opener__icon-wrapper--${classModifier}`,
        classesOpenLeft('plus-icon-opener__icon-wrapper'),
      ]"
    >
      <SvgIcon
        class="plus-icon-opener__icon"
        :image="IconPlus"
      />
    </span>
    <Transition name="fade">
      <div
        v-if="isOpen"
        :id="`button-content-${title.toLowerCase().replace(/\s+/g, '-')}`"
        class="plus-icon-opener__info"
        :class="[
          `plus-icon-opener__info--${classModifier}`,
          classesOpenLeft('plus-icon-opener__info'),
        ]"
      >
        <span class="plus-icon-opener__title">{{ title }}</span>
        <button
          class="plus-icon-opener__cta"
          :aria-label="ariaLabel"
          @click="$emit('go-to-section', ankerLink)"
        >
          {{ label }}
        </button>
      </div>
    </Transition>
  </button>
</template>

<script>
import IconPlus from '@/assets/images/icon-plus.svg';

export default {
  name: 'PlusIconOpener',
  props: {
    title: { type: String, required: true },
    label: { type: String, required: true },
    ariaLabel: { type: String, required: true },
    ankerLink: { type: String, default: '' },
    xsOpenLeft: { type: Boolean },
    smOpenLeft: { type: Boolean },
    mdOpenLeft: { type: Boolean },
  },
  emits: ['go-to-section'],
  data() {
    return {
      IconPlus,
      isOpen: false,
    };
  },
  computed: {
    classModifier() {
      return this.isOpen ? 'open' : 'close';
    },
  },
  methods: {
    classesOpenLeft(className) {
      const items = [];
      if (this.xsOpenLeft) items.push(`${className}--xs-left`);
      if (this.smOpenLeft) items.push(`${className}--sm-left`);
      if (this.mdOpenLeft) items.push(`${className}--md-left`);
      return items;
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

@mixin leftContentStyle() {
  left: auto;
  right: 10px;
  padding-left: 20px;
  padding-right: 65px;
}

.plus-icon-opener {
  position: absolute;
  z-index: 1;
  display: flex;
  background: transparent;
  border: none;
  padding: 0;

  &__icon-wrapper {
    display: inline-block;
    position: relative;
    z-index: 1;
    width: 60px;
    height: 60px;
    transform: rotate(0);
    transition: transform 500ms ease-in-out;
    &--open {
      transform: rotate(45deg);
    }
  }

  &__icon {
    width: 60px;
    height: 60px;
    stroke-width: 1px;
  }

  &__title {
    @include font-size(15px, 18px);
    color: color(grey, 15000);
  }

  &__info {
    white-space: nowrap;
    background-color: color(white);
    overflow: hidden;
    border: 1px solid #6b6b6b;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    border-radius: 60px;
    height: 60px;
    position: absolute;
    padding-left: 0;
    padding-right: 0;
    top: 1px;
    display: flex;
    margin-left: -30px;
    left: 0;
    &--open {
      flex: 1;
      padding-left: 65px;
      padding-right: 20px;
      margin-left: 0;
    }

    @include mq(false, $mq-sm - 1) {
      &--xs-left {
        @include leftContentStyle;
      }
    }
    @include mq($mq-sm, $mq-md - 1) {
      &--sm-left {
        @include leftContentStyle;
      }
    }
    @include mq($mq-md) {
      &--md-left {
        @include leftContentStyle;
      }
    }
  }

  &__cta {
    background-color: transparent;
    text-decoration: underline 1px;
    border: none;
    padding: 0;
    @include font-size(21px, 25px);
    cursor: pointer;
    transition: color 0.5s ease;
    &:hover,
    &:focus {
      color: var(--color-link);
      text-decoration: underline 2px;
    }
  }

  :deep(.fade-enter-active, .fade-leave-active) {
    transition: all 0.5s ease;
  }

  :deep(.fade-enter, .fade-leave-to) {
    flex: 0;
    opacity: 0;
  }
}
</style>
